<template>
    <div class="applyTrial">
        <el-dialog class="apply-dialog" :visible.sync="dialogVisible" width="585px" :modal-append-to-body="false" :before-close="handleClose" :close-on-click-modal="false" :custom-class="'form-dialog'">
            <div class="apply_box">
                <div class="apply-title">申请测试</div>
                <div class="apply-form">
                    <el-form :model="applyForm" :rules="rules" ref="applyForm" label-position="top" width="440px">
                        <el-form-item prop="name" label="您的姓名">
                            <el-input v-model="applyForm.name" placeholder="请输入您的姓名"></el-input>
                        </el-form-item>
                        <el-form-item prop="company" label="您的公司">
                            <el-input v-model="applyForm.company" placeholder="请输入您的公司名称"></el-input>
                        </el-form-item>
                        <el-form-item prop="job" label="您的职务">
                            <el-input v-model="applyForm.job" placeholder="请输入您的职务"></el-input>
                        </el-form-item>
                        <el-form-item  prop="testCases" label="测试用途">
                            <el-checkbox-group v-model="applyForm.testCases">
                                <el-checkbox label="内容审核" name="testCases"></el-checkbox>
                                <el-checkbox label="虚假信息鉴别溯源" name="testCases"></el-checkbox>
                                <el-checkbox label="反欺诈风控" name="testCases"></el-checkbox>
                                <el-checkbox label="证件信息防篡改" name="testCases"></el-checkbox>
                                <el-checkbox label="版权保护" name="testCases"></el-checkbox>
                                <el-checkbox label="论文生成式内容检测" name="testCases"></el-checkbox>
                                <el-checkbox label="其它" name="testCases" @change="handleOtherChange"></el-checkbox>
                            </el-checkbox-group>
                        </el-form-item> 
                        <el-form-item class="form-item-otherAct" prop="otherAct">
                            <el-input type="textarea" v-show="isOtherChecked" v-model="applyForm.otherAct" placeholder="请简单描述您的使用场景"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button class="submit-btn" type="primary" @click="submitForm('applyForm')">提交</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </el-dialog>
        <el-dialog :custom-class="'audit-dialog1'"
            class="audit-dialog"
            :visible.sync="auditDialogVisible"
            width="380px"
            :modal-append-to-body="false"
        >
            <div class="dialog-logo audit-logo"></div>
            <span slot="footer" class="dialog-footer">
                <el-button class="btn" @click="auditDialogVisible = false">我知道了</el-button>
            </span>
        </el-dialog>
        <el-dialog :custom-class="'pass-dialog1'"
            class="pass-dialog"
            :visible.sync="passDialogVisible"
            width="380px"
            :modal-append-to-body="false"
        >
            <div class="dialog-logo pass-logo"></div>
            <span slot="footer" class="dialog-footer">
                <el-button class="btn btn--primary" type="primary" @click="gotoTest">立即测试</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import Api from '../api'

export default {
    data() {
        return {
            dialogVisible: false,
            auditDialogVisible: false,
            passDialogVisible: false,
            applyForm: {
                name: '',
                company: '',
                job: '',
                testCases: [],
                otherAct: ''
            },
            rules: {
                name: [
                    { required: true, message: '请输入您的姓名', trigger: 'blur' }
                ],
                company: [
                    { required: true, message: '请输入您的公司名称', trigger: 'blur' }
                ],
                job: [
                    { required: true, message: '请输入您的职务', trigger: 'blur' }
                ],
                testCases: [
                    { type: 'array', required: true, message: '请至少选择一个测试用途', trigger: 'change' }
                ]
            }
        }
    },
    computed: {
        submitTestCases() {
            return this.applyForm.testCases.join(',')
        },
        isOtherChecked() {
            return this.applyForm.testCases.indexOf('其它') !== -1
        }
    },
    methods: {
        //显示表单
        showApplyForm(){
            this.dialogVisible = true
        },
        showPassDialog(){
            this.passDialogVisible = true
        },
        showAuditDialog(){
            this.auditDialogVisible = true
        },
        //提交申请测试
        submitForm(formName) {
            const params = {
                "name": this.applyForm.name,
                "company": this.applyForm.company,
                "job": this.applyForm.job,
                "acts": this.submitTestCases,
                "otherAct": this.applyForm.otherAct
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    Api.applyTrial(params).then(res => {
                        if (res.code === 200) {
                            this.$message.success('申请测试成功！')
                        }
                    }).finally(() => {
                        this.dialogVisible = false
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        //立即测试
        gotoTest() {
            this.$router.push({
                path: '/safeContent'
            })
        },
        handleOtherChange() {
            this.applyForm.otherAct = ''
        },
        handleClose() {
            this.$refs['applyForm'].resetFields()
            this.dialogVisible = false
        }
    }
}
</script>
<style lang="scss">
 .mobile{
    .form-dialog{
        transform: scale(1.5);
        margin-top: 35vh !important;
        
    }
      .pass-dialog1{
            //scale(2.5) translate(-50%, -50%) 
            transform: scale(2.5) !important;
        }
       .audit-dialog1{
            transform: scale(2.5) !important;
        }
}
</style>
<style lang="scss" scoped>

.applyTrial{
    width: 585px;
    background: #FFFFFF;
 
    .apply-dialog {
        /deep/ .el-dialog {
            margin-top: 80px ;
            border-radius: 8px;
        }
        /deep/ .el-dialog__header {
        padding: 0;
        .el-dialog__headerbtn {
            top: 15px;
            right: 15px;
            .el-dialog__close {
                width: 13px;
                height: 13px;
                font-family: PingFang SC;
                font-weight: 200;
                color: #556F88;
            }
        }
    }
    /deep/ .el-dialog__body {
        padding: 60px 70px;
        border-radius: 8px;
        background: url('../assets/apply_top.jpg') top left / 585px 231px no-repeat;
    }
    }
    
    .apply_box{
        width: 440px;
    }
    .apply-title {
        overflow: hidden;
        white-space: nowrap;
        text-indent: 500em;
        width: 110px;
        height: 26px;
        margin-bottom: 40px;
        background: url('../assets/sqcs.png') center center /contain no-repeat;
    }
    .apply-form {
        /deep/ .el-form-item__label {
            line-height: 14px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #111111;
        }
        /deep/ .el-input__inner:focus {
            border-color: #60B1F9;
        }
        /deep/ .el-checkbox-group {
            display: grid;
            grid-template-columns: 136px 1fr;
            .el-checkbox__label {
                font-size: 14px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #666666;
            }
            .el-checkbox__inner {
                box-sizing: border-box;
                width: 22px;
                height: 22px;
                border: 1px solid #DDE3E8;
                border-radius: 4px;
                &::after {
                    display: none;
                }
            }
            .is-checked .el-checkbox__inner {
                background: url('../assets/bg-checked.png') center center / contain no-repeat;
            }
        }
        .form-item-otherAct {
            margin-top: -20px;
        }
        .submit-btn {
            width: 440px;
            margin-top: 21px;
            background: #0078EF;
            border-radius: 4px;
            font-size: 16px;
            font-weight: 400;
        }
    }
    .pass-dialog, .audit-dialog {
        /deep/ .el-dialog {
            margin-top: 0 !important;
            border-radius: 8px;
            position: absolute;
            top: 40%;
            left: 50%;
            // transform: translate(-50%, -50%);
            margin-left: -190px;
            .el-dialog__header {
                padding: 0;
            }
            .el-dialog__headerbtn {
                top: 15px;
                right: 11px;
                .el-dialog__close {
                    color: #556F88
                }
            }
            .el-dialog__body {
                padding: 25px 34px 0;
            }
            .el-dialog__footer {
                padding: 13px 34px 32px;
            }
        }
        .dialog-logo {
            width: 191px;
            height: 191px;
            margin: 0 auto;
        }
        .audit-logo {
            background: url('../assets/bg-audit.png') center center / contain no-repeat;
        }
        .pass-logo {
            background: url('../assets/bg-pass.png') center center / contain no-repeat;
        }
        .btn{
            color: #0078EF;
            border: 1px solid #0078EF;
            border-radius: 4px;
            display: block;
            width: 100%;
            font-size: 16px;
            font-weight: 400;
            &--primary {
                color: white;
                background-color: #0078EF;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/ApplyTrial.vue